import { UTable } from '@components/common/UTable/UTable';

import { useGetDictionariesQuery } from '@/api/dictionaries/api';
import { columnsNumber } from '@/pages/Vaccination/components/task/columns.config';
import { EventProtocol } from '@/pages/Vaccination/components/task/types';

import cl from './styles.module.scss';

export const ProtocolEventsItem = ({
  drugId,
  administrationRouteIds,
  researchTypeId,
  animalSpeciesId,
  individuals,
}: EventProtocol) => {
  const { data: dictionaries } = useGetDictionariesQuery();
  const animalSpeciesName = animalSpeciesId
    ? dictionaries?.dictMap?.ANIMAL_SPECIES[animalSpeciesId]?.name || ''
    : '';

  return (
    <>
      <div className={`${cl.wrap} ${animalSpeciesId ? cl.wrapWithGroup : ''}`}>
        <div>
          <span className={cl.title}>Мероприятие:</span>
          <p>{dictionaries?.dictMap?.RESEARCH_TYPE[researchTypeId]?.name || ''}</p>
        </div>
        <div>
          <span className={cl.title}>Препарат:</span>
          <p>{dictionaries?.dictMap?.DRUG[drugId]?.name || ''}</p>
        </div>
        <div>
          <span className={cl.title}>Способ введения:</span>
          <p>
            {administrationRouteIds
              ?.map(
                (value: string) =>
                  dictionaries?.dictMap?.ADMINISTRATION_ROUTE[value]?.name || '',
              )
              ?.join(', ') || ''}
          </p>
        </div>
        {animalSpeciesId && (
          <div>
            <span className={cl.title}>Группа:</span>
            <p>{animalSpeciesName}</p>
          </div>
        )}
      </div>
      <UTable
        className="order-table order-column-number"
        size={'small'}
        data={individuals}
        columns={columnsNumber(dictionaries?.dictMap)}
      />
    </>
  );
};
